/* Superfly Cart Quick-Add — standalone drop-in.
   Injects an "add signature scents" strip at the TOP of the cart drawer so shoppers
   can add more bottles without leaving (or scrolling) the cart. Hooks window.sfCart.
   Tier copy is read live from the tier-discount-ladder (.sf-tier). Replaces the
   theme's upsell bar with a "You're saving ₹X" line next to Subtotal. No core edits.
   Install: upload to assets/ + one script line in theme.liquid before </body>. */
(function () {
  'use strict';

  /* ══ EDIT ME ══ */
  var CONFIG = {
    collection: 'all',        // collection handle to pull scents from
    limit: 8,                 // max products in the strip
    exclude: [],              // product handles to hide, e.g. ['gift-card']
    heading: 'Add signature scents',
    emptyHeading: 'Pick your signature scents',
    /* the theme's pink price-based ship-bar conflicts with the qty-based tier
       ladder (free shipping at 2 bottles) — remove it from the drawer */
    hideShipBar: true,
    /* what shipping costs when NOT free — used to show real ₹ saved */
    shippingValue: 8000,
    /* brand orange — used for the cart count badge (was theme yellow) */
    badgeBg: '#FFD1A9',
    /* on-brand sticker shown across sold-out product cards */
    oosBadge: {
      enabled: true,
      script: 'gone flying!',
      caps: 'sold out \u00b7 back soon'
    },
    /* pincode checker — reads window.SF_BOLT_PINCODES (superfly-bolt-pincodes.js) */
    pincode: {
      enabled: true,
      fastText: '24\u201348 hour delivery',
      standardText: 'Delivery in 3\u20135 days'
    },
    /* card background per product — same colours as the homepage product cards.
       Matched against the product title (case-insensitive substring). */
    colors: {
      'pink pepper':  '#FFB3C6',
      'sky bloom':    '#A9D6E5',
      'spring rain':  '#B2D3A8',
      'coral crush':  '#FFD1A9'
    }
  };

  var PALETTE = ['#FFB3C6', '#A9D6E5', '#B2D3A8', '#FFD1A9'];
  var products = null;
  var oosVariants = {}; /* variant id → true when sold out (from storefront JSON) */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  function colorFor(p, i) {
    var t = (p.title || '').toLowerCase();
    for (var k in CONFIG.colors) {
      if (t.indexOf(k) !== -1) return CONFIG.colors[k];
    }
    return PALETTE[i % PALETTE.length];
  }

  function loadProducts() {
    if (window.SFAM_MOCK_PRODUCTS) {
      products = window.SFAM_MOCK_PRODUCTS;
      products.forEach(function (p) { if (p.soldOut) oosVariants[p.id] = true; });
      return Promise.resolve();
    }
    return fetch('/collections/' + CONFIG.collection + '/products.json?limit=' + CONFIG.limit)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        products = (d.products || [])
          .filter(function (p) { return CONFIG.exclude.indexOf(p.handle) === -1; })
          .map(function (p) {
            var v = null;
            for (var i = 0; i < p.variants.length; i++) {
              if (p.variants[i].available !== false) { v = p.variants[i]; break; }
              oosVariants[p.variants[i].id] = true;
            }
            var soldOut = !v;
            v = v || p.variants[0];
            if (!v) return null;
            return {
              id: v.id,
              title: p.title,
              price: Math.round(parseFloat(v.price) * 100),
              image: (p.images && p.images[0] && p.images[0].src) || '',
              soldOut: soldOut
            };
          })
          .filter(Boolean);
      })
      .catch(function () { products = []; });
  }

  function cartItems() {
    return (window.sfCart && window.sfCart.data && window.sfCart.data.items) || [];
  }

  function totalQty() {
    return cartItems().reduce(function (a, i) { return a + i.quantity; }, 0);
  }

  function inCartQty(variantId) {
    var q = 0;
    cartItems().forEach(function (i) {
      if (i.variant_id === variantId || i.id === variantId) q += i.quantity;
    });
    return q;
  }

  /* ── tier ladder: single source of truth = .sf-tier (tier-discount-ladder snippet) ── */
  function ladder() {
    var n = document.querySelector('.sf-tier');
    var d = (n && n.dataset) || {};
    return {
      tiers: [
        { q: Number(d.t1Qty || 2), p: Number(d.t1Pct || 5) },
        { q: Number(d.t2Qty || 3), p: Number(d.t2Pct || 8) },
        { q: Number(d.t3Qty || 4), p: Number(d.t3Pct || 10) }
      ],
      ship: Number(d.shipQty || 4)
    };
  }

  function tierState(qty) {
    var L = ladder();
    var cur = null, next = null;
    for (var i = 0; i < L.tiers.length; i++) {
      if (qty >= L.tiers[i].q) cur = L.tiers[i];
      else { next = L.tiers[i]; break; }
    }
    return { cur: cur, next: next, ship: L.ship };
  }



  function savingsAt(qty, subtotal, pct, ship) {
    var save = Math.round(subtotal * pct / 100);
    if (qty >= ship) save += CONFIG.shippingValue;
    return save;
  }

  /* savings line beside Subtotal — replaces the theme's upsell bar (overkill) */
  function syncSavings() {
    var up = document.getElementById('cart-upsell');
    if (up) { up.hidden = true; up.innerHTML = ''; }
    var subEl = document.getElementById('cart-subtotal');
    if (!subEl) return;
    var subRow = subEl.closest('.row') || subEl.parentElement;
    var old = document.getElementById('sfam-saved-row');
    var qty = totalQty();
    var s = tierState(qty);
    if (!qty || !s.cur) { if (old) old.remove(); return; }
    var subtotal = (window.sfCart && window.sfCart.data && window.sfCart.data.total_price) || 0;
    var save = savingsAt(qty, subtotal, s.cur.p, s.ship);
    var label = 'You\u2019re saving \u00b7 ' + (qty >= s.ship ? 'free shipping + ' : '') + s.cur.p + '% off';
    if (!old) {
      old = document.createElement('div');
      old.id = 'sfam-saved-row';
      old.className = 'row sfam-saved';
      old.setAttribute('data-testid', 'cart-savings-row');
      subRow.parentElement.insertBefore(old, subRow);
    }
    old.innerHTML = '<span>' + label + '</span><span class="sfam-saved-amt">\u2212' + money(save) + '</span>';
  }

  /* ── confetti: on-brand flower burst when a new tier unlocks ── */
  var lastTierIdx = null;

  function tierIndex(qty) {
    var t = ladder().tiers, idx = 0;
    for (var i = 0; i < t.length; i++) if (qty >= t[i].q) idx = i + 1;
    return idx;
  }

  function burst() {
    var anchor = document.getElementById('sfam-saved-row') || document.querySelector('.sf-tier') || document.getElementById('cart-drawer-body');
    if (!anchor) return;
    var r = anchor.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var colors = ['#FFB3C6', '#A9D6E5', '#B2D3A8', '#FFD1A9', '#F4D03F'];
    for (var i = 0; i < 24; i++) {
      var el = document.createElement('div');
      el.className = 'sfam-petal';
      el.setAttribute('data-testid', 'tier-confetti');
      var c = colors[i % colors.length];
      el.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="' + c + '"><path d="M12 1c2.4 4 2.4 7 0 9.5C9.6 8 9.6 5 12 1zm0 22c-2.4-4-2.4-7 0-9.5 2.4 2.5 2.4 5.5 0 9.5zM1 12c4-2.4 7-2.4 9.5 0C8 14.4 5 14.4 1 12zm22 0c-4 2.4-7 2.4-9.5 0 2.5-2.4 5.5-2.4 9.5 0zM4.2 4.2c4.5 1.1 6.7 3.3 6.9 6.9-3.6-.2-5.8-2.4-6.9-6.9zm15.6 15.6c-4.5-1.1-6.7-3.3-6.9-6.9 3.6.2 5.8 2.4 6.9 6.9zM19.8 4.2c-1.1 4.5-3.3 6.7-6.9 6.9.2-3.6 2.4-5.8 6.9-6.9zM4.2 19.8c1.1-4.5 3.3-6.7 6.9-6.9-.2 3.6-2.4 5.8-6.9 6.9z"/><circle cx="12" cy="12" r="2.4" fill="#0a0a0a"/></svg>';
      el.style.cssText = 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;z-index:100000;pointer-events:none;';
      document.body.appendChild(el);
      var ang = Math.random() * Math.PI * 2, dist = 60 + Math.random() * 120;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 60;
      el.animate([
        { transform: 'translate(-50%,-50%) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) rotate(' + Math.round(Math.random() * 720 - 360) + 'deg) scale(' + (0.4 + Math.random() * 0.9) + ')', opacity: 0 }
      ], { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
      setTimeout((function (e) { return function () { e.remove(); }; })(el), 1700);
    }
  }

  function inject() {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (CONFIG.hideShipBar) {
      var sb = body.querySelector('.ship-bar');
      if (sb) sb.remove();
    }
    if (!products || !products.length) { injectPincode(body); return; }
    var old = body.querySelector('.sfam');
    if (old) old.remove();

    var qty = totalQty();

    /* confetti when a new savings tier unlocks (never on first paint) */
    var ti = tierIndex(qty);
    if (lastTierIdx !== null && ti > lastTierIdx) burst();
    lastTierIdx = ti;

    var wrap = document.createElement('div');
    wrap.className = 'sfam' + (qty === 0 ? ' sfam-empty' : '');
    wrap.setAttribute('data-testid', 'cart-quick-add');

    /* in-cart scents sink low; sold-out scents sink to the very bottom */
    var sorted = products
      .map(function (p, i) { return { p: p, i: i, q: inCartQty(p.id) }; })
      .sort(function (a, b) {
        return ((a.p.soldOut ? 1 : 0) - (b.p.soldOut ? 1 : 0)) || (a.q - b.q) || (a.i - b.i);
      });

    var cards = sorted.map(function (s, i) {
      var p = s.p, inCart = s.q;
      var bg = colorFor(p, s.i);
      return '<div class="sfam-card' + (p.soldOut ? ' sfam-card--oos' : '') + '" data-testid="quick-add-card-' + (i + 1) + '">' +
        (p.image
          ? '<img class="sfam-img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" style="background:' + bg + '">'
          : '<span class="sfam-swatch" style="background:' + bg + '">' + esc(p.title.charAt(0)) + '</span>') +
        '<p class="sfam-title">' + esc(p.title) + '</p>' +
        '<p class="sfam-price">' + money(p.price) + '</p>' +
        (inCart ? '<p class="sfam-incart">In cart ×' + inCart + '</p>' : '') +
        (p.soldOut
          ? '<span class="sfam-oos" data-testid="quick-add-soldout-' + (i + 1) + '">Sold out</span>'
          : '<button type="button" class="sfam-add" data-sfam-add="' + p.id + '" data-title="' + esc(p.title) + '" data-testid="quick-add-btn-' + (i + 1) + '">+ Add</button>') +
        '</div>';
    }).join('');

    wrap.innerHTML =
      '<div class="sfam-headrow">' +
        '<p class="sfam-head">' + esc(qty === 0 ? CONFIG.emptyHeading : CONFIG.heading) + '</p>' +
      '</div>' +
      '<div class="sfam-row">' + cards + '</div>';

    /* strip sits BELOW the line items (high-visibility card); jumps to top only when cart is empty */
    if (qty === 0 && body.firstChild) body.insertBefore(wrap, body.firstChild);
    else body.appendChild(wrap);

    injectPincode(body);

    wrap.querySelectorAll('[data-sfam-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        var id = Number(btn.getAttribute('data-sfam-add'));
        if (window.sfCart && window.sfCart.add) {
          window.sfCart.add(id, 1, { title: btn.getAttribute('data-title') });
        }
      });
    });

    syncSavings();
  }

  /* ── pincode serviceability (Bolt next-day delivery) ── */
  var PIN_KEY = 'sf_pincode';
  var pinMem = null; /* fallback when localStorage is blocked (e.g. Safari private mode) */

  function pinGet() {
    try { return localStorage.getItem(PIN_KEY) || pinMem; } catch (e) { return pinMem; }
  }
  function pinSet(v) {
    pinMem = v;
    try { if (v === null) localStorage.removeItem(PIN_KEY); else localStorage.setItem(PIN_KEY, v); } catch (e) {}
  }

  function pinLookup(pin) {
    var map = window.SF_BOLT_PINCODES || {};
    return map[pin] || null;
  }

  var PIN_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>';
  var BOLT_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z"/></svg>';

  function injectPincode(body) {
    if (!CONFIG.pincode.enabled) return;
    var old = body.querySelector('.sfpin');
    if (old) old.remove();
    var saved = pinGet();

    var box = document.createElement('div');
    box.className = 'sfpin';
    box.setAttribute('data-testid', 'cart-pincode');

    if (saved && /^\d{6}$/.test(saved)) {
      var city = pinLookup(saved);
      if (city) {
        box.innerHTML =
          '<div class="sfpin-hit">' +
            '<p class="sfpin-main">' + BOLT_SVG + ' ' + esc(CONFIG.pincode.fastText) + '</p>' +
            '<p class="sfpin-sub" data-testid="pincode-eta">' + saved + ' \u00b7 ' + esc(city) + '</p>' +
          '</div>' +
          '<button type="button" class="sfpin-change" data-pin-change data-testid="pincode-change">Change</button>';
      } else {
        box.innerHTML =
          '<div>' +
            '<p class="sfpin-main">' + PIN_SVG + ' Delivering to <b>' + saved + '</b></p>' +
            '<p class="sfpin-sub" data-testid="pincode-eta">' + esc(CONFIG.pincode.standardText) + '</p>' +
          '</div>' +
          '<button type="button" class="sfpin-change" data-pin-change data-testid="pincode-change">Change</button>';
      }
      box.querySelector('[data-pin-change]').addEventListener('click', function () {
        pinSet(null);
        injectPincode(body);
      });
    } else {
      box.innerHTML =
        '<div class="sfpin-form">' +
          '<p class="sfpin-main">' + PIN_SVG + ' Check delivery for your pincode</p>' +
          '<div class="sfpin-row">' +
            '<input type="text" inputmode="numeric" maxlength="6" placeholder="Enter pincode" class="sfpin-input" data-testid="pincode-input" aria-label="Pincode">' +
            '<button type="button" class="sfpin-btn" data-pin-check data-testid="pincode-check">Check</button>' +
          '</div>' +
          '<p class="sfpin-err" data-testid="pincode-error" hidden>Please enter a valid 6-digit pincode</p>' +
          '<p class="sfpin-sub">' + BOLT_SVG + ' 24\u201348 hour delivery in select pincodes</p>' +
        '</div>';
      var input = box.querySelector('.sfpin-input');
      var check = function () {
        var v = (input.value || '').trim();
        if (!/^\d{6}$/.test(v)) {
          box.querySelector('.sfpin-err').hidden = false;
          return;
        }
        pinSet(v);
        injectPincode(body);
      };
      box.querySelector('[data-pin-check]').addEventListener('click', check);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') check(); });
    }
    body.appendChild(box);
  }

  /* ── storefront stock guard ──
     1) disables any add button pointing at a sold-out variant (e.g. homepage
        .prange-add[data-variant-id]) and relabels it "Sold out";
     2) wraps sfCart.add so NO surface can add a sold-out variant. */
  function stockToast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:100001;background:#0a0a0a;color:#faf8f3;border-radius:999px;padding:11px 22px;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;pointer-events:none';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 1800);
  }

  function addOosBadge(el) {
    if (!CONFIG.oosBadge.enabled) return;
    var card = el.closest('.sfpc') || el.closest('article') || el.closest('li');
    if (!card || card.querySelector('.sfam-oos-badge')) return;
    var host = card.querySelector('.sfpc-imgwrap') || card;
    host.classList.add('sfam-oos-host');
    card.classList.add('sfam-oos-card');
    var b = document.createElement('div');
    b.className = 'sfam-oos-badge';
    b.setAttribute('data-testid', 'oos-badge');
    b.innerHTML =
      '<span class="sfam-oos-script">' + esc(CONFIG.oosBadge.script) + '</span>' +
      '<span class="sfam-oos-caps">' + esc(CONFIG.oosBadge.caps) + '</span>';
    host.appendChild(b);
  }

  function guardButtons() {
    document.querySelectorAll('[data-variant-id]').forEach(function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      if (vid && oosVariants[vid] && !btn.hasAttribute('data-sfam-oos-done')) {
        btn.setAttribute('data-sfam-oos-done', 'true');
        btn.disabled = true;
        btn.textContent = 'Sold out';
        btn.style.opacity = '.55';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('aria-disabled', 'true');
        addOosBadge(btn);
      }
    });
    /* quick-add forms (homepage product cards post /cart/add with a hidden id) */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !oosVariants[idInput.value] || form.hasAttribute('data-sfam-oos-done')) return;
      form.setAttribute('data-sfam-oos-done', 'true');
      form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); stockToast('Sold out — back soon'); }, true);
      addOosBadge(form);
      form.querySelectorAll('button[type="submit"], button:not([type])').forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = 'Sold out';
        btn.style.opacity = '.55';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('aria-disabled', 'true');
      });
    });
  }

  function guardCartAdd() {
    if (!window.sfCart || typeof window.sfCart.add !== 'function' || window.sfCart.__sfamGuarded) return;
    var origAdd = window.sfCart.add.bind(window.sfCart);
    window.sfCart.add = function (id, qty, meta) {
      if (oosVariants[id] || oosVariants[String(id)]) {
        stockToast('Sold out — back soon');
        return Promise.resolve();
      }
      return origAdd(id, qty, meta);
    };
    window.sfCart.__sfamGuarded = true;
  }

  function hook() {
    if (!window.sfCart || typeof window.sfCart.render !== 'function') {
      return void setTimeout(hook, 150);
    }
    guardCartAdd();
    guardButtons();
    var orig = window.sfCart.render.bind(window.sfCart);
    window.sfCart.render = function () { orig(); inject(); };
    if (window.sfCart.data) inject();
  }

  var style = document.createElement('style');
  style.textContent =
    '.sfam{margin:14px 0 12px;padding:14px;background:#efebe1;border:2px solid #0a0a0a;border-radius:20px}' +
    '.sfam-headrow{margin-bottom:10px}' +
    '.sfam-head{margin:0;font-size:14px;font-weight:900;text-transform:uppercase;letter-spacing:.12em}' +
    '.sfam-row{display:flex;gap:10px;overflow-x:auto;padding:2px 2px 10px;-webkit-overflow-scrolling:touch;scrollbar-width:none}' +
    '.sfam-row::-webkit-scrollbar{display:none}' +
    '.sfam-card{flex:0 0 116px;background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:16px;padding:10px;display:flex;flex-direction:column;align-items:flex-start}' +
    '.sfam-img,.sfam-swatch{width:100%;height:84px;object-fit:contain;background:#efebe1;border-radius:12px;margin-bottom:8px}' +
    '.sfam-swatch{display:flex;align-items:center;justify-content:center;font-weight:900;font-size:22px;color:#0a0a0a}' +
    '.sfam-title{margin:0;font-size:11px;font-weight:800;text-transform:uppercase;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.sfam-price{margin:2px 0 0;font-size:12px;font-weight:700;opacity:.7}' +
    '.sfam-incart{margin:2px 0 0;font-size:9px;font-weight:900;text-transform:uppercase;letter-spacing:.08em;color:#1a7f37;background:#e9f6ec;border-radius:999px;padding:2px 7px}' +
    '.sfam-add{margin-top:8px;background:#0a0a0a;color:#faf8f3;border:2px solid #0a0a0a;border-radius:999px;padding:6px 14px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;cursor:pointer;transition:transform .15s ease}' +
    '.sfam-add:hover{transform:translateY(-1px)}' +
    '.sfam-add:disabled{opacity:.55;cursor:wait}' +
    '.sfam-card--oos{opacity:.62}' +
    '.sfam-card--oos .sfam-img,.sfam-card--oos .sfam-swatch{filter:grayscale(.7)}' +
    '.sfam-oos{margin-top:8px;display:inline-block;background:#e5e0d3;color:#0a0a0a;border-radius:999px;padding:6px 14px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.12em}' +
    '.sfam-saved{color:#1a7f37;font-weight:800;font-size:13px;text-transform:uppercase;letter-spacing:.04em}' +
    '.sfam-saved-amt{font-weight:900}' +
    '.sfpin{margin:0 0 14px;padding:13px 14px;background:#fff;border:2px solid #0a0a0a;border-radius:20px;display:flex;align-items:center;justify-content:space-between;gap:12px}' +
    '.sfpin-main{margin:0;font-size:12.5px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;display:flex;align-items:center;gap:7px;line-height:1.4;flex-wrap:wrap}' +
    '.sfpin-main svg{flex:0 0 auto}' +
    '.sfpin-sub{margin:5px 0 0;font-size:11.5px;font-weight:700;opacity:.75;display:flex;align-items:center;gap:6px;letter-spacing:.04em}' +
    '.sfpin-hit .sfpin-main{color:#1a7f37}' +
    '.sfpin-change{background:none;border:0;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;text-decoration:underline;text-underline-offset:3px;cursor:pointer;color:#0a0a0a;padding:4px;flex:0 0 auto}' +
    '.sfpin-form{flex:1}' +
    '.sfpin-row{display:flex;gap:8px;margin-top:9px}' +
    '.sfpin-input{flex:1;min-width:0;border:2px solid #0a0a0a;border-radius:999px;padding:9px 16px;font-size:14px;font-weight:700;font-family:inherit;background:#faf8f3;letter-spacing:.08em}' +
    '.sfpin-input:focus{outline:2px solid #FFD1A9;outline-offset:2px}' +
    '.sfpin-btn{background:#0a0a0a;color:#faf8f3;border:2px solid #0a0a0a;border-radius:999px;padding:9px 20px;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.14em;cursor:pointer}' +
    '.sfpin-err{margin:7px 0 0;font-size:11px;font-weight:700;color:#c0392b}' +
    '.sfam-oos-host{position:relative}' +
    '.sfam-oos-badge{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-7deg);background:#0a0a0a;color:#faf8f3;border-radius:18px;padding:13px 24px;text-align:center;z-index:3;box-shadow:4px 5px 0 rgba(10,10,10,.28);pointer-events:none;white-space:nowrap}' +
    '.sfam-oos-script{display:block;font-family:"Chantal","Sofia Pro",cursive;font-size:24px;line-height:1;margin-bottom:5px;text-transform:lowercase}' +
    '.sfam-oos-caps{display:block;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.22em}' +
    '.sfam-oos-card .sfpc-bottle,.sfam-oos-card .sfpc-life,.sfam-oos-card img{filter:grayscale(.55) opacity(.85)}' +
    '.sfam-oos-card .sfam-oos-badge{filter:none}' +
    /* brand orange cart count badge (was theme yellow) */
    '.cart-count{background:' + CONFIG.badgeBg + ' !important}' +
    /* bigger tier numbers under the cream ladder bar */
    '.sf-tier-labels{font-size:12.5px !important;opacity:.75 !important}';
  document.head.appendChild(style);

  loadProducts().then(hook);
})();
;
